import get from 'lodash/get'

export const getAwardedExperienceUserItem = (state, id) => get(state, `userItem.${id}`, null)
